import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import calendar from '../../../../../../assets/images/meetupEvent/calendar.png';
import Clock from '../../../../../../assets/images/meetupEvent/clock-icon.png';
import Fly from '../../../../../../assets/images/Souvenir/unsplash_Z4RYz52ljts.png';
import SouvenirAuctionBanner from '../../../../../../assets/images/SouvenirJoti.png';
import axios from 'axios';
import moment from 'moment';
import { Markup } from 'interweave';
import { serverInfo } from '../../../../../../App';
import { useContext } from 'react';


const ApprovedOrDecline = () => {
    const { imageCdnUrl } = useContext(serverInfo);
    const {id} = useParams()

    let history = useHistory();

    const approved = () => {

        axios.put(`/api/star/approved/auction/${id}`).then((res) => {
    
            if (res.status === 200) {
                history.push(`/superstar/auction`)
            }
            
          });
    }
    // function editProduct(){
    //     history.push(`/superstar-admin/souvenir/edit-auction/${auctionConfirm.id}`)
    // }

    const[auctionConfirm, setConfirmation]=useState([]);


    useEffect(() => {

        axios.get(`/api/star/approvedOrDecline/auction/${id}`).then((res) => {
    
          if (res.status === 200) {
            setConfirmation(res.data.product);
          }
          
        });
    
      }, []);
    


    return (
        <div>
            <div>
                <img className='w-100' src={imageCdnUrl + auctionConfirm.banner} alt="" style={{height:'400px', width:'1080px' }}/>
            </div>
            <div className="row my-3">



                <div className="col-md-8 mb-5">
                    <div className="card card-bg shadow">
                        <div className="card-body">
                            <h5 className="text-light mb-3">
                            {auctionConfirm.name}
                            </h5>
                            <p className="text-light">
                                <Markup content={auctionConfirm.details} />
                            </p>
                            <p className="text-light ">
                            {auctionConfirm.title}
                            </p>
                        </div>
                    </div>

                    <div className=" d-flex mt-5 mb-5 cricket-jersey">
                        <div className="d-flex p-4 registration-btn">
                            <div className="mt-2  mx-3 ">
                                <span className="text-light"> <img src={calendar} alt="" className='PriceTage' /></span>
                            </div>
                            <div className=" mx-1">
                                <span className="text-light">Last Date</span>
                                <br></br>
                                <span className="text-warning  BtnTextNMP Usd fw-bold">{moment(auctionConfirm.bid_to).format('LL')}</span>
                            </div>
                        </div>

                        <div className=" d-flex p-4 registration-btn ">
                            <div className=" mt-2 mx-3">
                                <span className="text-light"> <img src={Clock} alt="" className='PriceTage' /></span>
                            </div>
                            <div className=" mx-1 ">
                                <span className="text-light">Time</span>
                                <br></br>
                                <span className="text-warning  BtnTextNMP Usd fw-bold">{moment(auctionConfirm.bid_to).format('LT')}</span>
                            </div>
                        </div>
                    </div>

                        <div className='d-flex'>
                        <Link>
                            <button onClick={approved} className="btn btn-warning confirmButton">Approved</button>
                        </Link>
                        <Link to={`/superstar/auction`}>
                            <button className="btn btn-secondary mx-2 deleteButton">Decline</button>
                        </Link>

                        </div>

                </div>


                <div className="col-md-4 ">
                    <img src={imageCdnUrl + auctionConfirm.product_image} alt="Pineapple" className='img-fluid Cricket-Img'/>
                </div>

            </div>

        </div>
    );
};

export default ApprovedOrDecline;